import { render, staticRenderFns } from "./UnPatrolList.vue?vue&type=template&id=58e4a696&"
import script from "./UnPatrolList.vue?vue&type=script&lang=js&"
export * from "./UnPatrolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports